import { RouteLocationNormalizedGeneric, RouteLocationNormalizedLoadedGeneric, NavigationGuardNext } from "vue-router"
import { useUserAuthenticatedStore } from "../../components/AuthComponent/stores/UserAuthenticated.store"



const redirectUserWithLoginOk = async(
    _to:RouteLocationNormalizedGeneric, 
    _from:RouteLocationNormalizedLoadedGeneric, 
    next:NavigationGuardNext
) => {

    const userStore = useUserAuthenticatedStore()

    

    try {

        await userStore.initializeUserStore();
        
        if(userStore.checkUserAuth){

            return next({
                path: '/table-content'
            })
        }

        // Si ya estamos en home y no estamos autenticados, permitir sin redirección
        if (_to.name === 'home' && !userStore.checkUserAuth) {
            return next()
        }

        

        return next()


    } catch (error) {
        console.error('Error de autenticacion: ', error)
        return next({
            name: 'home'
        })
    }
} 


export default redirectUserWithLoginOk;